import { apiService } from "../services/api";
import type { AppDispatch } from "../state/store";
import { showAlertDialog } from "../state/utils/confirmationDialogUtils";

export const PURCHASE_RETURN_BLOCKED_ALERT_TITLE =
  "Purchase Return Not Allowed";

export type PurchaseReturnPartsIssueValidation = {
  allowed: boolean;
  message: string;
};

export const isPurchaseReturnContext = (
  screenId?: string | null,
  moduleEndpoint?: string | null
): boolean => {
  const sid = String(screenId || "").trim();
  const module = String(moduleEndpoint || "").trim();
  if (module === "pur_ret_add") return true;
  if (sid === "126" || sid === "18") return true;
  if (sid.includes("purchase_return")) return true;
  return false;
};

export const resolvePurchaseIdForValidation = (
  ...sources: Array<Record<string, any> | undefined | null>
): string | undefined => {
  for (const source of sources) {
    if (!source) continue;
    for (const key of [
      "purchase_id",
      "drp_purchase_ret",
      "purchase_no",
      "txt_purchaseno",
    ]) {
      const value = source[key];
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        return String(value).trim();
      }
    }
  }
  return undefined;
};

export async function showPurchaseReturnBlockedAlert(
  dispatch: AppDispatch,
  message: string
): Promise<void> {
  await showAlertDialog(dispatch, message, PURCHASE_RETURN_BLOCKED_ALERT_TITLE);
}

export async function validatePurchaseReturnPartsIssue(
  purchaseId: string
): Promise<PurchaseReturnPartsIssueValidation> {
  const response = await apiService.get<{
    success?: boolean;
    allowed?: boolean;
    message?: string;
  }>(
    `/pabws/module/pur_ret_add/validate_parts_issue/${encodeURIComponent(
      purchaseId
    )}`
  );

  const allowed =
    response?.allowed === true || response?.success === true;
  return {
    allowed,
    message:
      response?.message ||
      "Purchase return is not allowed until Parts Issue Return is completed for batches issued from this purchase.",
  };
}
